import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Button } from '../../Button';
import { SeeMoreLessList } from '../../SeeMoreLessList';
import { VscCloudDownload, VscMail } from 'react-icons/vsc';
import { GiFloatingPlatforms } from 'react-icons/gi';
import { FiDatabase, FiGitPullRequest } from 'react-icons/fi';
import { MdComputer, MdLanguage, MdOutlineCloud } from 'react-icons/md';
import './Resume.css';

function Resume() {
    return (
        <>
            <Helmet>
                <title>Kai Cheng | Resume</title>
                <meta name='description' content='I am Kai Cheng, a senior software engineer from Ottawa, Ontario, Canada. I have a rich experience in e-commerce, web development, and cloud computing.' />
                <link rel='canonical' href='https://www.kaicheng.ca/resume/' />
            </Helmet>
            <h1>Kai's Resume</h1>
            <section className='resume__container mb-50'>
                <h2 className='resume__container__title mb-30'>About Me</h2>
                <div className='element'>
                    <div className='col-33'>
                        <img src='/images/kai.png' className='headshot' alt='Kai Cheng' loading='lazy' />
                    </div>
                    <div className='col-66'>
                        <div className='element-container'>
                            <h3 className='mb-20'>Hello,</h3>
                            <p className='mb-20'>
                                I am Kai Cheng, a senior software engineer from Ottawa, Ontario, Canada. I have a rich experience in e-commerce, web development, and cloud computing.
                                I am a collaborative, team-player that is able to lead.
                                I graduated from Carleton University with a Bachelor of Computer Science with a focus in Mobile Application Development and a minor in Business in 2014.
                                I am a very active person, I play soccer, basketball, volleyball, golf, and enjoy going running and skiing.
                                I love to explore and go on adventures and I've been fortunate to travel to many parts of the world.
                            </p>
                            <div className='element mb-20'>
                                <div className='row'>
                                    <div className='col-50'>
                                        <p className='mb-10 text-888'>Name: <span className='text-dark'>Kai Cheng</span></p>
                                        <p className='mb-0 text-888'>Website: <span className='text-dark'><Link to='/'>https://www.kaicheng.ca/</Link></span></p>
                                    </div>
                                    <div className='col-50 mt-10'>
                                        <p className='mb-10 text-888'>Location: <span className='text-dark'>Ottawa, ON, Canada</span></p>
                                        {/*<p className='mb-0 text-888'>Email: <span className='text-dark'>blah@blah.com</span></p>*/}
                                    </div>
                                </div>
                            </div>
                            <Link to='/uploads/kai-cheng-resume.pdf' className='mr-10' target='_blank'>
                                <Button buttonStyle='btn--small' buttonColor='red' >
                                    <VscCloudDownload className='btn-icon' />
                                    Download CV
                                </Button>
                            </Link>
                            <Link to='/contact'>
                                <Button buttonStyle='btn--small' buttonColor='blue'>
                                    <VscMail className='btn-icon' />
                                    Hire Me
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className='resume__container mb-50'>
                <h2 className='resume__container__title mb-30'>My skills</h2>
                <div className='element'>
                    <div className='skills col-33'>
                        <div className='elementor-widget-container mb-20'>
                            <div className='skill-item'>
                                <MdLanguage className='icon' />
                                <h4 className='mb-10 mt-10'>Languages & Frameworks</h4>
                                <p>Java, Spring Boot</p>
                                <p>JavaScript, HTML, CSS</p>
                            </div>
                        </div>
                        <div className='elementor-widget-container'>
                            <div className='skill-item'>
                                <GiFloatingPlatforms className='icon' />
                                <h4 className='mb-10 mt-10'>Architectures & Platforms</h4>
                                <p>Event-Driven Architecture (Kafka)</p>
                                <p>Microservices, Oracle Commerce</p>
                            </div>
                        </div>
                    </div>
                    <div className='skills col-33'>
                        <div className='elementor-widget-container mb-20'>
                            <div className='skill-item'>
                                <MdOutlineCloud className='icon' />
                                <h4 className='mb-10 mt-10'>Cloud</h4>
                                <p>AWS (DynamoDB, S3, IAM, Lambda, KMS, Secrets Manager</p>
                            </div>
                        </div>
                        <div className='elementor-widget-container'>
                            <div className='skill-item'>
                                <FiDatabase className='icon' />
                                <h4 className='mb-10 mt-10'>Databases</h4>
                                <p>SQL, DynamoDB, MongoDB</p>
                            </div>
                        </div>
                    </div>
                    <div className='skills col-33'>
                        <div className='elementor-widget-container mb-20'>
                            <div className='skill-item'>
                                <MdComputer className='icon' />
                                <h4 className='mb-10 mt-10'>Observability & Monitoring</h4>
                                <p>Datadog, Splunk</p>
                            </div>
                        </div>
                        <div className='elementor-widget-container'>
                            <div className='skill-item'>
                                <FiGitPullRequest className='icon' />
                                <h4 className='mb-10 mt-10'>DevOps & Tooling</h4>
                                <p>Git, GitLab, CI/CD</p>
                                <p>Jenkins, Atlassian JIRA</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='resume__container mb-50'>
                <h2 className='resume__container__title mb-30'>Work Experience</h2>
                <div className='resume__card not-last mb-20'>
                    <div className='company-details mb-20'>
                        <div className='company-logo'>
                            <img src='/images/pivotree.jpg' className='logo-img' alt='Pivotree' loading='lazy' />
                        </div>
                        <div className='company-summary'>
                            <h3>Pivotree</h3>
                            <h4>Ottawa, ON, Canada</h4>
                        </div>
                    </div>
                    <div className='roles'>
                        <div className='role'>
                            <div className='role-details-timeline'>
                                <div className='role-heading-node mb-10'>
                                    <h4>Senior Software Engineer</h4>
                                    <span>2018 - Present</span>
                                </div>
                                <div className='role-description'>
                                    <p className='mb-10'>Pivotree is a single point-of-contact company for all e-commerce, MDM & cloud hosting needs offering expert design, implementation, and application support services.</p>
                                </div>
                                <div className='role-heading-node mb-10'>
                                    <h4>Client: lululemon | 2020 - 2026</h4>
                                </div>
                                <div className='role-description'>
                                    <SeeMoreLessList
                                        items={[
                                            'Technical owner for backend systems supporting post-purchase eCommerce experiences, ensuring reliability, scalability, and performance',
                                            'Designed and implemented Java-based microservices powering high-volume production systems handling 2M+ requests/day',
                                            'Built event-driven architectures using Kafka, enabling scalable and resilient distributed workflows',
                                            'Deployed and managed services using Docker and Kubernetes in a cloud-native environment',
                                            'Owned production systems end-to-end, including observability (Datadog, Splunk), incident response, and performance tuning',
                                            'Led resolution of critical production incidents, performing root cause analysis and driving long-term system improvements',
                                            'Improved CI/CD pipelines and release processes, increasing deployment reliability and reducing release friction',
                                            'Partnered with cross-functional teams (product, QA, architecture) to align technical design with business goals',
                                            'Mentored engineers and contributed to engineering best practices and code quality standards'
                                        ]}
                                        maxItems={9} />
                                </div>
                            </div>
                        </div>
                        <div className='role'>
                            <div className='role-details'>
                                <div className='role-heading-node mb-10'>
                                    <h4>Software Engineer</h4>
                                    <span>2018</span>
                                </div>
                                <div className='role-description'>
                                    <p className='mb-10'>Pivotree is a single point-of-contact company for all e-commerce, MDM & cloud hosting needs offering expert design, implementation, and application support services.</p>
                                    <SeeMoreLessList
                                        items={[
                                            'Developed backend systems using Java and Oracle Commerce (ATG) for enterprise eCommerce clients',
                                            'Resolved critical performance and scalability bottlenecks, significantly improving page load times and system responsiveness',
                                            'Implemented SEO improvements that increased organic search visibility and traffic',
                                            'Integrated third-party APIs (payment providers, analytics platforms) ensuring reliable and secure system interactions'
                                        ]}
                                        maxItems={1} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='resume__card not-last mb-20'>
                    <div className='company-details mb-20'>
                        <div className='company-logo'>
                            <img src='/images/thinkwrap.jpg' className='logo-img' alt='Thinkwrap' loading='lazy' />
                        </div>
                        <div className='company-summary'>
                            <h3>Thinkwrap Commerce</h3>
                            <h4>Ottawa, ON, Canada</h4>
                        </div>
                    </div>
                    <div className='roles'>
                        <div className='role'>
                            <div className='role-details-timeline'>
                                <div className='role-heading-node mb-10'>
                                    <h4>Software Developer</h4>
                                    <span>2015 - 2018</span>
                                </div>
                                <div className='role-description'>
                                    <p className='mb-10'>Thinkwrap Commerce was an e-commerce integration company specializing in Oracle Commerce (ATG) and SAP Hybris.</p>
                                    <SeeMoreLessList
                                        items={[
                                            'Provide Oracle ATG & Java expertise on a variety of ATG projects',
                                            'Design, implement, and extend the Commerce catalog',
                                            'Created dynamo servlet beans (droplets), form handlers, and generic services',
                                            'Integrated the front and back end code in order to meet the business objectives set within the organization',
                                            'Integration with 3rd parties and payment providers',
                                            'SEO development to improve page ranking and provide analytics',
                                            'Fixed web related bugs in JSPs using html, css, and javascript',
                                            'Refactored, debugged and fixed code issues including implementation of new change requests'
                                        ]}
                                        maxItems={3} />
                                </div>
                            </div>
                        </div>
                        <div className='role'>
                            <div className='role-details'>
                                <div className='role-heading-node mb-10'>
                                    <h4>Technical Support Specialist</h4>
                                    <span>2013 - 2015</span>
                                </div>
                                <div className='role-description'>
                                    <p className='mb-10'>Thinkwrap Commerce was an e-commerce integration company specializing in Oracle Commerce (ATG) and SAP Hybris.</p>
                                    <SeeMoreLessList
                                        items={[
                                            'Managed and maintained large scale production environments',
                                            'Deployed new releases to all environments',
                                            'Investigated incidents, provided root cause analysis and resolution',
                                            'Established, implemented and documented procedures/principles in the company’s Wiki',
                                            'Implemented Cron jobs & scripts in Production environments for automated processes',
                                            'Maintained consistent communication with business stakeholders through incidents and problems',
                                            'Diffused client problems through effective listening skills, positive actions and information gathering while providing 24/7 technical and application support for core business applications'
                                        ]}
                                        maxItems={1} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='resume__card not-last mb-20'>
                    <div className='company-details mb-20'>
                        <div className='company-logo'>
                            <img src='/images/env-canada2.jpg' className='logo-img' alt='Environment Canada' loading='lazy' />
                        </div>
                        <div className='company-summary'>
                            <h3>Environment Canada</h3>
                            <h4>Ottawa, ON, Canada</h4>
                        </div>
                    </div>
                    <div className='role'>
                        <div className='role-details'>
                            <div className='role-heading mb-10'>
                                <h4>Student Developer</h4>
                                <span>2012</span>
                            </div>
                            <div className='role-description'>
                                <SeeMoreLessList
                                    items={[
                                        'Maintained and upgraded a system used to manage ice information',
                                        'Built off of existing code and tested and debugged newly written code',
                                        'Used VB.NET and version control software (AccuRev)'
                                    ]}
                                    maxItems={3} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='resume__card'>
                    <div className='company-details mb-20'>
                        <div className='company-logo'>
                            <img src='/images/carleton.png' className='logo-img' alt='Carleton' loading='lazy' />
                        </div>
                        <div className='company-summary'>
                            <h3>Carleton University</h3>
                            <h4>Ottawa, ON, Canada</h4>
                        </div>
                    </div>
                    <div className='role'>
                        <div className='role-details'>
                            <div className='role-heading mb-10'>
                                <h4>Mobile Applications Developer</h4>
                                <span>2011</span>
                            </div>
                            <div className='role-description'>
                                <SeeMoreLessList
                                    items={[
                                        'Created well designed and user friendly iOS applications using Xcode as an IDE',
                                        'Rideau Timescapes is an iOS app that allows the visitor to interact with the visual heritage of lock stations along the canal in a whole new way',
                                    ]}
                                    maxItems={2} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='resume__container mb-50'>
                <h2 className='resume__container__title mb-30'>Certifications</h2>
                <div className='resume__card not-last mb-20'>
                    <div className='company-details mb-20'>
                        <div className='company-logo'>
                            <img src='/images/aws.jpg' className='logo-img' alt='AWS' loading='lazy' />
                        </div>
                        <div className='company-summary'>
                            <h3>AWS Certified Cloud Practitioner</h3>
                            <h4>Amazon Web Services (AWS)</h4>
                        </div>
                    </div>
                </div>
                <div className='resume__card'>
                    <div className='company-details mb-20'>
                        <div className='company-logo'>
                            <img src='/images/safe.jpg' className='logo-img' alt='SAFe' loading='lazy' />
                        </div>
                        <div className='company-summary'>
                            <h3>Certified SAFe® 5 Practitioner</h3>
                            <h4>Scaled Agile, Inc.</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className='resume__container mb-50'>
                <h2 className='resume__container__title mb-30'>Education</h2>
                <div className='resume__card'>
                    <div className='company-details mb-20'>
                        <div className='company-logo'>
                            <img src='/images/carleton.png' className='logo-img' alt='Carleton' loading='lazy' />
                        </div>
                        <div className='company-summary'>
                            <h3>Carleton University</h3>
                            <h4>Ottawa, ON, Canada</h4>
                        </div>
                    </div>
                    <div className='role'>
                        <div className='role-details'>
                            <div className='role-heading mb-10'>
                                <h4>Bachelor of Computer Science, Mobile Computing Stream</h4>
                                <span>2014</span>
                            </div>
                            <div className='role-description'>
                                <p>I graduated with an Honours in Computer Science in the Mobile Computing Stream with a minor in Business and coop option. Participated in numerous Intramural sports.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Resume;
